import React from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';

const buttonStyle = {
  float: "right",
  marginLeft: "10px"
};

class TaskView extends React.Component {

  constructor(props) {
    super(props);

    this.onDelete = this.onDelete.bind(this);
    this.onComplete = this.onComplete.bind(this);
  }

  onDelete() {
    if (this.props.onDelete) {
      this.props.onDelete(this.props.task);
    }
  }

  onComplete() {
    if (this.props.onComplete) {
      this.props.onComplete(this.props.task);
    }
  }

  render() {

    const { task, allowDelete, allowComplete, user } = this.props;

    const start = moment(task.attributes.startTime).format('YYYY-MM-DD hh:mm A');
    const end = moment(task.attributes.endTime).format('YYYY-MM-DD hh:mm A');
    const timeRange = `${start} - ${end}`;
    const resourceName = task.attributes.user ? task.attributes.user.name : 'Unassigned';
    const currentUserId = task.attributes.user ? task.attributes.user.id : 0;
    const showComplete = allowComplete && !task.attributes.completed && task.attributes.accepted && user.id == currentUserId;
    const status = task.attributes.completed ? "Completed" : task.attributes.accepted ? "In Progress" : "Pending";
    const hours = task.attributes.hoursOfWork ? task.attributes.hoursOfWork : "N/A";

    return (
      <tr>
        <td>{timeRange}</td>
        <td>{resourceName}</td>
        <td>{status}</td>
        <td>{hours}</td>
        <td>
          {allowDelete && (<a className="icon-remove" title="remove" onClick={this.onDelete} >&#xe912;</a>)}
          {showComplete && (<span style={buttonStyle}>
            <button data-tooltip="Complete" onClick={this.onComplete} type="button">Complete</button>
          </span>)}</td>
      </tr>
    );
  }
}

TaskView.propTypes = {
  task: PropTypes.object.isRequired,
  allowDelete: PropTypes.bool,
  onDelete: PropTypes.func,
  onComplete: PropTypes.func
}

export default TaskView;



// WEBPACK FOOTER //
// ./src/components/projects/Tasks/TaskView.js